import RedirectMyGoal from './RedirectMyGoal';

export default RedirectMyGoal;
